module.exports = __webpack_public_path__ + "img/tree-05-b-leaves.aa4fa31c.png";